import styled from 'styled-components';
import { Icon } from '@appcues/sonar';

export const CopyIcon = styled(Icon).attrs({
  size: 'small',
  colorToken: 'color-blurple-600',
})``;
